module.exports = {
  baseApi: process.env.VUE_APP_BASE_API || 'http://localhost:3000/api',
  mapsKey: process.env.VUE_APP_GOOGLE_MAPS_KEY || ''
}
